var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContactsFragmentContactMetadata',{attrs:{"profile":_vm.profile,"show-parent-custody":_vm.showParentCustody}},[_c('p',{staticClass:"m-0"},[_vm._v("\n    "+_vm._s(_vm.profileName)+"\n    ("+_vm._s(_vm.relationText)+")\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }